import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import Hero from "../../components/medical/Hero";
import HighlightedContactSection from "../../components/HighlightedContactSection";

export default function SuccessStoriesPage() {
  const location = useLocation();

  const site = location.pathname.startsWith("/sales")
    ? "sales"
    : "medical";

  const [logos, setLogos] = useState([]);

  useEffect(() => {
    const loadLogos = async () => {
      try {
        const basePath = `/logos/${site}`;

        const response = await fetch(
          `${basePath}/logos.json?v=${Date.now()}`
        );

        if (!response.ok) {
          throw new Error("Logo-Liste konnte nicht geladen werden");
        }

        const files = await response.json();

        if (!Array.isArray(files)) {
          throw new Error("logos.json enthält kein Array");
        }

        setLogos(
          files.map((filename) => `${basePath}/${filename}`)
        );
      } catch (error) {
        console.error("Fehler beim Laden der Referenzlogos:", error);
        setLogos([]);
      }
    };

    loadLogos();
  }, [site]);

  return (
    <>
      <Hero
        title="Referenzen"
        subheading="Erfolge und Erfahrungen unserer Mandanten."
      />

      <section className="bg-white py-16">
        <div className="container-app mx-auto">
          <h2 className="text-xl sm:text-3xl md:text-4xl font-semibold md:font-medium text-gray-900">
            Personalsuche? Erfolgreiche Personalbeschaffung
            <br />
            durch Repexo!
          </h2>

          <p className="mt-4 text-base font-semibold text-gray-900 md:text-lg">
            Vertrauen Sie unseren Referenzen!
          </p>

          <p className="mt-2 text-sm leading-relaxed text-gray-700 md:text-base">
            Hier sehen Sie einen Auszug ausgewählter Kunden die auf Repexo zählen!
            <br />
            Gerne unterstützen wir auch Ihr Unternehmen bei der Besetzung vakanter Stellen.
          </p>

          <div className="mt-8 grid grid-cols-3 gap-4 sm:grid-cols-4 md:grid-cols-5">
            {logos.map((logo, i) => (
              <div
                key={i}
                className="flex items-center justify-center rounded-xl border border-gray-200 bg-white p-3"
              >
                <img
                  src={logo}
                  alt={`Logo eines Mandanten von REPEXO (${i + 1})`}
                  className="max-h-full max-w-full object-contain"
                />
              </div>
            ))}
          </div>
        </div>

        <HighlightedContactSection
          heading="Ihre Erfolgsgeschichte mit uns schreiben"
          description="Sie möchten erfahren, wie wir Mandanten bei der Besetzung unterstützen? Wir beraten Sie gerne."
          buttonText="Jetzt Kontakt aufnehmen"
          sectionId="section-erfolgsgeschichten-contact"
        />
      </section>
    </>
  );
}